/**
 * LayoutComponent.js - Componente base para componentes layout
 * 
 * Este componente base centraliza la lógica común de todos los componentes
 * layout, eliminando redundancias de código y proporcionando una interfaz
 * consistente para estilos y funcionalidades base.
 */

import React from 'react';
import { useLayoutStyles } from '../../hooks/useLayoutStyles';

/**
 * Componente base para componentes layout
 * @param {React.ReactNode} children - Contenido a renderizar
 * @param {boolean} isDarkMode - Estado del modo oscuro
 * @param {string} componentType - Tipo de componente layout
 * @param {string} className - Clase CSS adicional
 * @param {Object} customStyles - Estilos personalizados
 * @param {Object} props - Propiedades adicionales
 */
const LayoutComponent = ({ 
  children, 
  isDarkMode = false, 
  componentType = 'content',
  className = '',
  customStyles = {},
  ...props 
}) => {
  // Obtener estilos del hook personalizado
  const styles = useLayoutStyles(isDarkMode, componentType, customStyles);

  return (
    <div 
      style={styles} 
      className={className}
      {...props}
    >
      {children}
    </div>
  );
};

export default LayoutComponent;

